/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OrInputs */

const en_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const es_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o`)
};

const fr_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou`)
};

const de_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder`)
};

const ja_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`または`)
};

const zh_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或`)
};

const ar_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أو`)
};

const id_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atau`)
};

const it_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oppure`)
};

const ru_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`или`)
};

const pt_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou`)
};

const ko_or = /** @type {(inputs: OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`또는`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {OrInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const or = /** @type {((inputs?: OrInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OrInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_or(inputs)
	if (locale === "es") return es_or(inputs)
	if (locale === "fr") return fr_or(inputs)
	if (locale === "de") return de_or(inputs)
	if (locale === "ja") return ja_or(inputs)
	if (locale === "zh") return zh_or(inputs)
	if (locale === "ar") return ar_or(inputs)
	if (locale === "id") return id_or(inputs)
	if (locale === "it") return it_or(inputs)
	if (locale === "ru") return ru_or(inputs)
	if (locale === "pt") return pt_or(inputs)
	return ko_or(inputs)
});